module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("3")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("“Nobody’s Going to Kill You, Martin”")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("artin Luther King, Jr., and his entourage arrived back in Atlanta around 5:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". on Friday, March 29. He and his wife, Coretta, spent the evening at the home of Ralph and Juanita Abernathy. “He didn’t talk about the movement that night,” recalled Abernathy. “Instead he talked about the times before the Montgomery bus boycott when we were all younger and hadn’t taken on the burdens of the black people. He remembered people long forgotten, did some of his imitations, and told a few stories.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-1",
      "id": "ch03-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" After dinner, the two men retired to the family room, where they collapsed onto two matching loveseats, exhausted from the two days in Memphis. They slept there undisturbed until the following morning when Abernathy’s son came for breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Saturday, March 30, the SCLC staff held its regular meeting at the Ebenezer Baptist Church. The chief topic was the Poor People’s Campaign, but a return to Memphis was also debated. Andrew Young, James Bevel, and Jesse Jackson presented objections to Memphis. King, who arrived late, listened uncomfortably to the griping. Abernathy noticed that King seemed particularly restless and downhearted. When he finally spoke, King said it was necessary to make another trip to Memphis. But his top aides were opposed, fearful that any further diversion of resources to Memphis would inalterably harm the march on Washington. Cancel Washington, if Memphis must be done, was the common "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("sentiment."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-2",
      "id": "ch03-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" King chastised them for their disunity, and halfway through the meeting he stood up, took a set of car keys from Abernathy, and walked out."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-3",
      "id": "ch03-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abernathy followed him into the hallway. When he asked King if he was all right, King tried to reassure him, but Abernathy later recalled having a “deep sense of foreboding. He seemed preoccupied and depressed.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-4",
      "id": "ch03-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Jesse Jackson had stepped out of the meeting to see if there was a problem. When King saw him, he snapped, “Jesse, it may be necessary for you to carve your own individual niche in society. But don’t you bother me.” Jackson was stunned. King walked outside and drove away. When Abernathy returned to the meeting, he impressed upon the staff how much strain King was under, and that they needed to come together to make it easier for him. It was not the right time for conflict and division within the ranks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within an hour, a new timetable had been set. King would keep a long-scheduled preaching commitment at National Cathedral in Washington on Sunday, March 31. That same day Andrew Young, Hosea Williams, and James Bevel would travel to Memphis and start the nonviolence workshops. Jackson and the rest of the SCLC staff would arrive on Monday, April 1. Finally, on Tuesday, the second, King, Abernathy, and Bernard Lee would travel to Memphis. The new march was tentatively set for Friday, April 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now Abernathy called King and pleaded with him to return to the meeting. King took several hours to get there."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-5",
      "id": "ch03-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" He listened impassively as the staff informed him of its decisions. “He was still in a strange mood,” recalled Abernathy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-6",
      "id": "ch03-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Sunday morning, King and Andrew Young flew to Washington, and after King’s sermon they met with reporters to stress that the Poor People’s Campaign was still on target. He also reiterated his opposition to Lyndon Johnson’s reelection campaign. Later, they met with Michigan congressman John Conyers and Gary, Indiana, mayor Richard Hatcher to discuss a possible “commission of inquiry” to examine the positions of all 1968 presidential candidates as they related to blacks. That evening, King’s spirits were noticeably buoyed by Lyndon Johnson’s unexpected announcement that he would not seek reelection."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-7",
      "id": "ch03-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King returned to Atlanta on Sunday evening. On Monday, while his staffers met with the Invaders and ministers in Memphis, King rested, saw no one in the organization, and tried to regain his physical and mental balance. It was on April 1 that the SCLC publicly announced that King would return to Memphis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, King finally called Abernathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you?” Abernathy asked. “Where have you been?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Around,” replied King. “Don’t worry about it. We can go tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But we’re due today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Please, let’s not go till tomorrow.”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Although Abernathy worried that the others “would be disappointed and even angry,” he heard the “plaintive quality” in King’s voice and relented."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-8",
      "id": "ch03-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" The following day, April 3, when they finally boarded a plane for the flight to Memphis, it remained at the gate for an unusually long time. The pilot finally announced that a bomb threat had delayed them, but every piece of luggage had been checked, and they were now cleared for takeoff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King laughed. “Well, it looks like they won’t kill me this flight, not after telling me all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody’s going to kill you, Martin,” said Abernathy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-9",
      "id": "ch03-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King just looked out the plane’s window, staring at the runway. Abernathy thought he noticed a tight smile.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("On Monday, April 1, the day the SCLC made the official announcement that King would return to Memphis, Annie Estelle Peters, the manager at the Piedmont Laundry in Atlanta, was on duty. Shortly after 10:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., a white man came in with some clothing. He was pale, thin, with dark hair, and sported horn-rimmed glasses. He placed four undershirts, three pairs of briefs, a pair of socks, and a washcloth on the counter. He also gave her a suit jacket, a separate pair of dress trousers, and a tie for dry cleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I have your name, please?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eric Galt.” He spelled it for her."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-10",
      "id": "ch03-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her customer seemed so neatly dressed, and yet he was in the middle of Atlanta’s small but intense hippie district. With his neatly combed hair, suit, and crisp shirt, he seemed anything but a hippie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A decaying green-and-white rooming house around the corner from the laundry served as Galt’s Atlanta address. Like Peters, Jimmie Garner, the manager, thought his neatly dressed middle-aged tenant did not fit with the rest of his young “flower-power” roomers. Galt had arrived two days earlier, paid cash for his $10.50-a-week room, and was a quiet boarder who kept to himself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-11",
      "id": "ch03-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" At the rear of the rooming house, in a tiny gravel-covered lot, he parked his pale yellow Mustang (so light that everyone later remembered it as white). It bore an Alabama license plate and had two Mexican tourist visa stickers stamped October 1967 on the windshield. Neighbors later recalled it because they were aggravated that Galt parked the car diagonally across three parallel parking spaces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Wednesday, April 3, Galt drove along U.S. Highway 78 toward Birmingham. At some point, he pulled off the highway and stopped near a secluded spot. Getting out of his car, he opened the trunk and retrieved the Browning "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("box that contained his new rifle. Although Aeromarine had bore-sighted the scope for accuracy, he wanted to get a feeling for the gun. He set the Redfield scope to its maximum magnification, seven power. He fired about two dozen shots at trees, rocks, leaves, whatever seemed a good target. With the scope, items a hundred yards away seemed virtually in front of him. Satisfied with his new Remington, Galt carefully placed it back into the Mustang’s trunk."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch03-03-12",
      "id": "ch03-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" After he passed through Birmingham, he stayed on Highway 78. Memphis was only 250 miles away.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f9dbf5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 84
// module chunks = 0